"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useAction;

var _react = require("react");

var _resift = require("resift");

function useAction(actionCreator) {
  var dispatch = (0, _resift.useDispatch)();
  return (0, _react.useCallback)(function () {
    return dispatch(actionCreator.apply(void 0, arguments));
  }, [dispatch, actionCreator]);
}